import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Table } from '../../../../common/table'
import { schema } from './constant'
import { selectCellData, selectIds } from './store/slice'

export const BusinessYearsTable = ({ isDynamicReport }) => {
  const ids = useSelector(selectIds)

  return (
    <Table
      ids={ids}
      getDataFromRedux={selectCellData}
      isStickyFirstCol={!isDynamicReport}
      isNoDataWithHead={!isDynamicReport}
      isDisplayScroll={!isDynamicReport}
      isNoStickyHead={isDynamicReport}
      isDynamicReport={isDynamicReport}
      schema={Object.values(schema).map((item) => {
        return {
          colId: item.key,
          title: item.title,
          isI18n: true,
          thStyle: item.thStyle,
          render: (val, { locale }) => {
            switch (item.key) {
              case schema.numberCompanies.key:
              case schema.totalPercentCompanies.key:
                return <div className="textEnd">{item.format(val, locale)}</div>

              default:
                return item.format(val)
            }
          },
        }
      })}
    />
  )
}

BusinessYearsTable.propTypes = {
  isDynamicReport: PropTypes.bool,
}
